import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { GetAddonsComponent } from './components/get-addons/get-addons/get-addons.component';
import { GetUseRoleComponent } from './components/get-UseRole/get-use-role/get-use-role.component';
import { UnblockUserComponent } from './components/unblock-user/unblock-user/unblock-user.component';
import { UpdateContactComponent } from './components/updatecontact/updatecontact/updatecontact.component';
import { LoginComponent } from './auth/login/login.component';
import { PreloaderComponent } from './components/shared/preloader/preloader.component';
import { LoadingService } from './services/general/loading.service';
import { ErrorAlertComponent } from './components/shared/error-alert/error-alert.component';
import { SuppressedEmailComponentsComponent } from './components/suppressed-email-components/suppressed-email-components.component';
import { CrcConsultComponentsComponent } from './components/crc-consult-components/crc-consult-components.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoginComponent,
    ReactiveFormsModule,
    GetAddonsComponent,
    GetUseRoleComponent,
    UnblockUserComponent,
    UpdateContactComponent,
    PreloaderComponent,
    CommonModule,
    ErrorAlertComponent,
    SuppressedEmailComponentsComponent,
    CrcConsultComponentsComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'web-app';
  loading$: Observable<boolean>;

  constructor(
    private _loadingService : LoadingService
  ){
    this.loading$ = this._loadingService.loading$;
  }
}
